<style lang="less" scoped>
.messagec{width: 1200px;height: 570px;background-color: #fff;}
.title{margin-top: 20px;text-align: left;margin-left: 35px;font-size: 19px;font-weight: bold;color: #0152b5;
  .i{color: #0152b5;font-weight: 1000;}
  .el-icon-close{float: right;margin-right: 30px;}
}
.tabs{width: 94%;margin: 25px auto;}
.setting{position: absolute; right: 65px; top: 80px;z-index: 1000;
 span{font-size: 13px;padding-left: 10px;cursor: pointer;}
 /deep/.el-table__body-wrapper{
  overflow: auto;
  height: 370px;
 }
}
</style>
<template>
  <div class="messagec">
    <div class="title">
      <i class="el-icon-chat-dot-square"></i>消息中心
      <i class="el-icon-close" @click="onclose"></i>
    </div>
    <div class="tabs">
      <div class="setting">
        <span @click="setRead"><i class="el-icon-message"></i>全部置于已读</span>
        <span @click="clearAllMessa"><i class="el-icon-delete"></i>清空所有消息</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick" >
        <el-tab-pane label="全部消息" name="first" >
          <el-table
            :data="tableData"
            style="width: 100%;height:370px;overflow: auto;">
            <el-table-column
              prop="type"
              label="类型"
              width="200" >
              <template slot-scope="scope">{{ scope.row.type | messCenData() }}</template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="内容"
              width="650">
            </el-table-column>
            <el-table-column
              prop="date"
              label="时间">
              <template slot-scope="scope">{{ (scope.row.date * 1000) | formatTime() }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="未读消息" name="second">
          <el-table
            :data="tableDatas"
            style="width: 100%;height:370px;overflow: auto;">
            <el-table-column
              prop="type"
              label="类型"
              width="200">
              <template slot-scope="scope">{{ scope.row.type | messCenData() }}</template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="内容"
              width="650">
            </el-table-column>
            <el-table-column
              prop="date"
              label="时间">
              <template slot-scope="scope">{{ (scope.row.date * 1000) | formatTime() }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import filters from '../../backer/method/filter'

export default {
  mixins: [filters],
  data()
  {
    return {
      activeName: 'second',
      tableData: [],
      tableDatas: [],
      username: ''
    }
  },
  created()
  {
    this.getData()
  },
  methods: {
    handleClick(tab, event)
    {
      console.log(tab, event)
    },
    getData()
    {
      let uname = localStorage.getItem('username')
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 122,
        _exp: `username = ${uname} and status in (1,2)`,
        orderby: 'id Desc'
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.tableData = []
        this.tableDatas = []
        ret.forEach(val =>
        {
          if (val.status === 1)
            this.tableData.push(val)
          else if (val.status === 2)
            this.tableDatas.push(val)
        })
      })
    },
    setRead()
    {
      let uname = localStorage.getItem('username')
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 122,
        _exp: `username = ${uname}`,
        orderby: 'id Desc'
      }
      window.post.getPost(paras).then((ret) =>
      {
        ret.forEach(val =>
        {
          if (val.status === 2)
          {
            let objcontent = {
              cmd: 'updateAtt',
              _major: 11,
              _minor: 122,
              retAtt: 1,
              id: val.id,
              status: 1
            }
            window.post.getPost(objcontent).then((ret) =>
            {
              if (ret)
              {
                this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
                this.getData()
              }
            })
          }
        })
      })
    },
    clearAllMessa()
    {
      let uname = localStorage.getItem('username')
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 122,
        _exp: `username = ${uname} and status in (1,2)`,
        orderby: 'id Desc'
      }
      window.post.getPost(paras).then((ret) =>
      {
        ret.forEach(async(val) =>
        {
          let objcontent = {
            cmd: 'updateAtt',
            _major: 11,
            _minor: 122,
            retAtt: 1,
            id: val.id,
            status: 3
          }
          await window.post.getPost(objcontent)
        })
        this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
        this.getData()
      })
    },
    onclose()
    {
      this.$parent.openMessage()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/MessageCenter.vue